import React, { useState } from 'react';
import { LockClosedIcon } from '@heroicons/react/24/solid';
import { LOGIN_API_URL } from '../apiConfig';
import './LoginPage.css';

const LoginPage = ({ onLogin }) => {
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
    const response = await fetch(`${LOGIN_API_URL}/api/auth`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ 
            password: password  // Using the password from user input
        })
    });
    
    const data = await response.json();
    
    if (data.success) {
        localStorage.setItem('authToken', data.token);
        onLogin(true);
    } else {
        setError(data.message || 'Invalid password');
    }
} catch (error) {
    setError('Authentication failed. Please try again.');
} finally {
    setIsLoading(false);
}
    };

    return (
                <div className="min-h-screen bg-[#0B1121] flex items-center justify-center p-4 font-sans">
            <div className="w-full max-w-md">
                <div className="bg-black/20 backdrop-blur-xl rounded-2xl shadow-2xl p-8 border border-yellow-400/30 shadow-[0_0_25px_rgba(250,204,21,0.2)]">
                    <div className="text-center mb-8">
                        <img src="/My_Logo.jpeg" alt="StockAdi Logo" className="h-28 w-28 rounded-full object-cover mx-auto mb-4 border-2 border-yellow-400/50 shadow-[0_0_20px_rgba(250,204,21,0.4)]" />
                                                <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 via-blue-500 to-purple-500 mb-2">
                            StockAdi
                        </h1>
                        <p className="text-gray-300">
                            Enter your password to access your dashboard
                        </p>
                    </div>

                    <form 
                        onSubmit={handleSubmit}
                        className="space-y-6"
                    >
                        <div>
                            <div className="relative">
                                <LockClosedIcon className="h-5 w-5 text-purple-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                                                        className="w-full pl-10 pr-4 py-3 bg-black/20 border border-purple-400/30 rounded-lg focus:ring-2 focus:ring-purple-400 focus:border-transparent text-white placeholder-gray-400/50 transition-all"
                                    placeholder="Enter password"
                                    required
                                    autoComplete="new-password"
                                    aria-label="Password"
                                />
                            </div>
                            {error && (
                                <p className="mt-2 text-sm text-red-400">
                                    {error}
                                </p>
                            )}
                        </div>

                        <button
                            className={`w-full py-3 px-4 bg-gradient-to-r from-yellow-500 via-blue-500 to-purple-500 text-white rounded-lg font-bold shadow-lg hover:shadow-purple-400/40 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-offset-2 focus:ring-offset-gray-900 transition-all ${
                                isLoading ? 'opacity-75 cursor-not-allowed' : ''
                            }`}
                            disabled={isLoading}
                            type="submit"
                        >
                            {isLoading ? (
                                <div className="flex items-center justify-center">
                                    <div className="w-5 h-5 border-2 border-gray-900 border-t-transparent rounded-full animate-spin mr-2"></div>
                                    Authenticating...
                                </div>
                            ) : (
                                'Access Dashboard'
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
